import React from 'react';

interface LogoProps {
  className?: string;
  size?: number;
  color?: string;
}

export function Logo({ className, size = 32, color }: LogoProps) {
  const styles = {
    color: color,
    width: size,
    height: size,
  };

  return (
    <svg
      style={styles}
      className={className}
      viewBox="0 0 26 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 14.7368L9.17673 17.7958C11.2399 18.4835 12.6316 20.4143 12.6316 22.5891V32L3.45485 28.9411C1.39164 28.2534 0 26.3226 0 24.1477V14.7368Z" fill="currentColor" />
      <path d="M25.2632 14.7368L16.0864 17.7958C14.0232 18.4835 12.6316 20.4143 12.6316 22.5891V32L21.8083 28.9411C23.8715 28.2534 25.2632 26.3226 25.2632 24.1477V14.7368Z" fill="currentColor" />
      <path d="M4.63158 8C8.2806 6.54039 11.172 3.64903 12.6316 0C14.0912 3.64903 16.9826 6.54039 20.6316 8C16.9826 9.45961 14.0912 12.351 12.6316 16C11.172 12.351 8.2806 9.45961 4.63158 8Z" fill="currentColor" />
    </svg>
  );
}

